import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_STARTER_EXPERIENCE_DASHBOARD_DECISION_MAKER_REDESIGN = defineFcm(
	'starter_experience_dashboard_decision_maker_redesign',
)
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				experimentName: { type: 'string' },
				enabled: { type: 'boolean' },
			},
		}),
	)
	.withDefault({
		experimentName: 'starter_experience_dashboard_decision_maker_redesign_experiment',
		enabled: false,
	})
	.toConfig({
		owner: 'squad-axolotl',
		scope: 'corgi-front-end',
		context: 'Starter Dashboard',
		description: 'Gates the Decision Maker dashboard redesign (Phase 2) A/B experiment.',
		import: false,
		template: {
			experimentName: 'starter_experience_dashboard_decision_maker_redesign_experiment',
			enabled: false,
		},
	});
